module.exports = __webpack_public_path__ + "img/client-demo-product-v2.cc1ef02a.png";